import { __extends, __assign } from 'tslib';
import React__default from 'react';
import { customOptions, propTypes, defaultProps } from './TipSelector.types.js';
import styles from './TipSelector.module.scss.js';
import { Button } from '../Button/Button.component.js';
import NumberFormat from '../NumberFormat/NumberFormat.component.js';

var TipSelector = /** @class */ (function (_super) {
    __extends(TipSelector, _super);
    function TipSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onInputChange = function (values) {
            var selectedOption = _this.props.selectedOption;
            _this.props.onChange({
                label: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || '',
                value: values.floatValue || 0,
            });
        };
        _this.onSelectCustom = function () {
            var onChange = _this.props.onChange;
            onChange({
                value: 0,
                label: customOptions.FLAT,
            });
        };
        _this.onToggleCustomType = function () {
            var _a = _this.props, onChange = _a.onChange, selectedOption = _a.selectedOption;
            var customOption = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) === customOptions.FLAT
                ? customOptions.PERCENT
                : customOptions.FLAT;
            onChange({
                value: 0,
                label: customOption,
            });
        };
        return _this;
    }
    TipSelector.prototype.render = function () {
        var _a;
        var _b = this.props, options = _b.options, selectedOption = _b.selectedOption, allowCustom = _b.allowCustom, narrow = _b.narrow, disabled = _b.disabled, onChange = _b.onChange;
        var customType = (_a = this.props.selectedOption) === null || _a === void 0 ? void 0 : _a.label;
        var isCustom = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) === customOptions.FLAT ||
            (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) === customOptions.PERCENT;
        return (React__default.createElement("div", { className: "\n                    " + styles.TipSelector + "\n                    " + (narrow ? styles.TipSelector___narrow : '') + "\n                " },
            React__default.createElement("div", { className: styles.TipSelector_options },
                options.map(function (option) { return (React__default.createElement("button", { key: option.label, type: "button", disabled: disabled, className: "\n                                " + styles.TipSelector_option + "\n                                " + (option.label === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label)
                        ? styles.TipSelector_option___selected
                        : '') + "\n                            ", onClick: function () { return onChange(option); } }, option.label)); }),
                allowCustom && (React__default.createElement("button", { type: "button", disabled: disabled, className: "\n                                    " + styles.TipSelector_option + "\n                                    " + styles.TipSelector_option___custom + "\n                                    " + (isCustom
                        ? styles.TipSelector_option___selected
                        : '') + "\n                                ", onClick: this.onSelectCustom }, "Custom"))),
            allowCustom && isCustom && (React__default.createElement("div", { className: styles.TipSelector_inputContainer },
                React__default.createElement(NumberFormat, { className: styles.FocusedInput, value: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value)
                        ? String(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value)
                        : '', disabled: disabled, onValueChange: this.onInputChange, thousandSeparator: customType === customOptions.FLAT ? ',' : '' }),
                React__default.createElement("div", { className: styles.TipSelector_toggle },
                    React__default.createElement(Button, { variant: "secondary", className: styles.ToggleBtn, onClick: this.onToggleCustomType, type: "button", "data-testid": "toggle-button" }, (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) === customOptions.FLAT
                        ? '$'
                        : '%'))))));
    };
    TipSelector.displayName = 'TipSelector';
    TipSelector.propTypes = propTypes;
    TipSelector.defaultProps = __assign({}, defaultProps);
    return TipSelector;
}(React__default.Component));

export default TipSelector;
